import Vue from 'vue';
import Router from 'vue-router';
import VideoHome from './views/VideoHome';
import Booking from './views/Booking';
import AppointmentConfirmation from './views/AppointmentConfirmation';
import AppointmentError from './views/Iframe/AppointmentError';
import SecurePayment from './views/Iframe/SecurePayment';
import PaymentSuccessful from './views/Iframe/PaymentSuccessful';
import PaymentUnsuccessful from './views/Iframe/PaymentUnsuccessful';

Vue.use(Router);

const homeComponent = () => {
    const hasPartner = Boolean(process.env.VUE_APP_PARTNER_NAME);
    if (hasPartner) {
        return import('./views/Home.vue');
    } else {
        return import('./views/AscentiHome.vue');
    }
};

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: homeComponent
        },
        {
            path: '/video',
            name: 'video-home',
            component: VideoHome
        },
        {
            path: '/booking',
            name: 'booking',
            component: Booking
        },
        {
            path: '/secure-payment',
            name: 'secure-payment',
            component: SecurePayment
        },
        {
            path: '/payment/successful',
            name: 'payment-successful',
            component: PaymentSuccessful
        },
        {
            path: '/payment/unsuccessful',
            name: 'payment-unsuccessful',
            component: PaymentUnsuccessful
        },
        {
            path: '/confirmation',
            name: 'appointment-confirmation',
            component: AppointmentConfirmation
        },
        {
            path: '/confirmation/error',
            name: 'appointment-error',
            component: AppointmentError
        },
        {
            path: '*',
            component: {
                template: '',
                created: () => window.location.href = '/errors/404.html',
            },
        },
    ],
});

// Capture userId/groupId/expiry from query and persist to localStorage,
// then remove those keys from the visible URL while preserving other query params.
router.beforeEach((to, from, next) => {
    try {
        const sensitiveKeys = ['userId', 'groupId', 'expiry'];

        const present = sensitiveKeys.some(k => to.query && Object.prototype.hasOwnProperty.call(to.query, k));

        if (present) {
            // Use URL as source of truth: store/override values from the query into localStorage
            try {
                const raw = window.localStorage.getItem('memberParams');
                let stored = null;

                if (raw) {
                    stored = JSON.parse(raw);
                }

                const toStore = stored || {};
                let updated = false;

                sensitiveKeys.forEach(k => {
                    if (to.query[k] !== undefined) {
                        // If different from stored value, update
                        if (toStore[k] !== to.query[k]) {
                            toStore[k] = to.query[k];
                            updated = true;
                        }
                    }
                });

                if (updated) {
                    window.localStorage.setItem('memberParams', JSON.stringify(toStore));
                }
            } catch (e) {
                // ignore localStorage errors
            }

            // build a new query without the sensitive keys
            const newQuery = Object.keys(to.query || {}).reduce((acc, key) => {
                if (!sensitiveKeys.includes(key)) {
                    acc[key] = to.query[key];
                }
                return acc;
            }, {});

            // If queries differ, replace route (preserve other params)
            const same = Object.keys(newQuery).length === Object.keys(to.query || {}).length
                && Object.keys(newQuery).every(k => to.query[k] === newQuery[k]);

            if (!same) {
                next({ path: to.path, query: newQuery, replace: true });
                return;
            }
        }
    } catch (err) {
        // ignore
    }

    next();
});

export default router;
